import { Existing, GetArrayElementType, Merge } from '@xometry/ui';
import { RFQ_STATUS } from 'collections/enquiry';
import { EnquiryStates } from 'interfaces/stores/EnquiriesStore';
import { EnquiryQuery } from 'utils/graphql/queries/__generated__/enquiry';
import { EnquiryMaterialsQuery } from 'utils/graphql/queries/__generated__/enquiryMaterials';
import { MeasurementProtocolsQuery } from 'utils/graphql/queries/__generated__/measurementProtocols';

export enum EnquiryPartPriceOptionType {
  economy = 'economy',
  standard = 'standard',
  express = 'express',
}

export interface EnquiryPartPriceOption {
  default: boolean;
  lead_time: number;
  price_amount: number;
}

export interface EnquiryPartMaterialOption {
  [key: string]: Set<string>;
}

type IEnquiryGQL = Existing<EnquiryQuery['enquiry']>;
type IEnquiryPartGQL = IEnquiryGQL['parts'][number];

export type IEnquiryPart = Merge<
  IEnquiryPartGQL,
  {
    rfqStatus?: RFQ_STATUS | null;
    priceOptions?: Partial<Record<EnquiryPartPriceOptionType, EnquiryPartPriceOption | null>> | null;
  }
>;
export type IEnquiry = Merge<IEnquiryGQL, { state: EnquiryStates; parts: IEnquiryPart[] }>;

export type IEnquiryMaterial = Existing<IEnquiryPart['material']>;

type IEnquiryFeatureMaterialGQL = GetArrayElementType<Existing<EnquiryMaterialsQuery['enquiryMaterials']>>;
export type IEnquiryFeatureMaterial = IEnquiryFeatureMaterialGQL;

export type ITolerance = GetArrayElementType<IEnquiryFeatureMaterial['tolerancesNew']>;

type IMeasurementProtocolGQL = NonNullable<MeasurementProtocolsQuery['measurementProtocols']>[number];
export type IMeasurementProtocol = IMeasurementProtocolGQL;
